import { render, staticRenderFns } from "./MetricEditCategory.vue?vue&type=template&id=3a5a7312"
import script from "./MetricEditCategory.vue?vue&type=script&lang=js"
export * from "./MetricEditCategory.vue?vue&type=script&lang=js"
import style0 from "./MetricEditCategory.vue?vue&type=style&index=0&id=3a5a7312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports